"use client";

/**
 * NewForm DS hover icon — a capsule mic over its stand, for "record".
 * On hover the capsule lifts a hair toward the mouth, the gesture of
 * raising a mic rather than the whole glyph twitching.
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function MicIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <rect className="a-lift" x="9" y="2.8" width="6" height="10.4" rx="3" />
      <path d="M5.4 10.8v1.2a6.6 6.6 0 0 0 13.2 0v-1.2" />
      <path d="M12 18.6v2.6" />
    </HoverIconSvg>
  );
}
